import React, { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
interface ToolTipCommonComponentProps {
    toolTipText: string;
    children?: React.ReactNode;
    icon?: React.ReactNode;
    onClick?: () => void;
}

const ToolTipCommonComponent: React.FC<ToolTipCommonComponentProps> = ({
    toolTipText,
    children,
    icon,
    onClick,
  }) => {
    const hoverTarget: React.ReactNode =
      children !== undefined ? children : (icon || <InfoIcon fontSize="small" sx={{ color: '#9e9e9e' }} />);
    const hoverCursor: React.CSSProperties['cursor'] = children !== undefined ? 'help' : 'pointer';

    return (
      <Tooltip
        title={toolTipText}
        arrow
        placement="top-start"
        enterDelay={500}
        leaveDelay={200}
        PopperProps={{modifiers: [{name: 'offset',options: {offset: [0, 10],},},],sx: {'& .MuiTooltip-tooltip': {fontFamily: "'DM Sans', sans-serif",fontWeight:"700"},}}}>
        <span style={{ display: 'inline-flex', cursor: hoverCursor }} onClick={onClick}>
          {hoverTarget}
        </span>
      </Tooltip>
    );
  };

export {ToolTipCommonComponent}